import { takeLatest, put, call } from 'redux-saga/effects';
import { getNFTsActions } from './slice';
import { getAllNFTs, checkConnectivity } from './functions';

function* getNFTsReference({ payload }) {
  try {
    const response = yield call(getAllNFTs, payload);
    yield put(getNFTsActions.getNFTsSuccess(response));
  } catch (error) {
    yield put(getNFTsActions.getNFTsError(error));
  }
}
//
function* checkConnectivityReference() {
  try {
    const response = yield call(checkConnectivity);
    yield put(getNFTsActions.checkConnectivitySuccess(response));
  } catch (error) {
    yield put(getNFTsActions.checkConnectivityError(error));
  }
}
//
function* getNFTsSaga() {
  yield takeLatest(getNFTsActions.getNFTs.type, getNFTsReference);
  yield takeLatest(
    getNFTsActions.checkConnectivity.type,
    checkConnectivityReference
  );
}
//
export default getNFTsSaga;
